import { render } from "./PanelConsultaAprobacionView.vue?vue&type=template&id=24808589&scoped=true"
import script from "./PanelConsultaAprobacionView.vue?vue&type=script&lang=js"
export * from "./PanelConsultaAprobacionView.vue?vue&type=script&lang=js"

import "./PanelConsultaAprobacionView.vue?vue&type=style&index=0&id=24808589&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24808589"]])

export default __exports__